import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { offers } from './Reducers/Offers.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { overlay } from './Reducers/Overlay.reducer';
import { advancedSearch } from './Reducers/AdvancedSearch.reducer';
import { productsView } from './Reducers/ProductsView.reducer';
import { wheelBuilder } from './Reducers/WheelBuilder.reducer';
import { contactUs } from './Reducers/ContactUs.reducer';
import { login } from './Reducers/Login.reducer';
import { carPreview } from './Reducers/CarPreview.reducer';
import { quickOrder } from './Reducers/QuickOrder.reducer';
import { priceMargins } from './Reducers/PriceMargins.reducer';
import { priceToggle } from './Reducers/PriceToggle.reducer';
import { priceDisplayQuantity } from './Reducers/PriceDisplayQuantity.reducer';

const staticReducers = {
  cart,
  offers,
  quickSearch,
  navigation,
  facetedSearch,
  checkout,
  myPage,
  overlay,
  advancedSearch,
  productsView,
  wheelBuilder,
  contactUs,
  login,
  carPreview,
  quickOrder,
  priceMargins,
  priceToggle,
  priceDisplayQuantity,
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
};

export default app;
